<template>
  <div style="margin-top: 50px">
    <div class="has-ribbon" style="margin-top: 50px">
      <div class="ribbon is-large is-warning">Audio</div>
    </div>
    <h1 class="subtitle has-text-grey radha-thero">
      <font-awesome-icon icon="headphones" />
      පූජ්‍ය කන්දේකුඹුරෙ රාධ ස්වාමීන්වහන්ස විසින් දේශිත ධර්ම දේශනා
    </h1>
    <hr class="is-divider" data-content="අමාදොර" />

    <div
      class="columns is-multiline"
      style="margin-left: 50px; margin-right: 50px"
    >
      <div
        v-for="audio in audios"
        :key="audio.id"
        class="column is-one-fifth-fullhd is-one-quarter-desktop is-one-third-tablet"
        data-aos="zoom-in-up"
        data-aos-delay="800"
        data-aos-duration="1000"
      >
        <div class="card">
          <div class="card-image is-1by1">
            <youtube
              :video-id="audio.id"
              @ready="ready"
              height="200hv"
              width="100%"
            />
          </div>
          <div class="card-content">
            <div class="subtitle has-text-grey is-5">{{ audio.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Audios",
  methods: {
    ready() {
      // console.log("ready");
    }
  },
  data() {
    return {
      audios: [
        {
          id: "YTSRvc9afpI",
          title: "පියජාතික සූත්‍රය"
        },
        {
          id: "LEL-Nox0rkc",
          title: "මහා වෙස්සන්තර ජාතක දේශනාව"
        },
        {
          id: "T5JYKhyhs4M",
          title: "ධාතු වර්ණනාව"
        },
        {
          id: "dOjiBuC853E",
          title: "ප්‍රීති සම්බොජ්ඣංග දේශනය"
        },
        {
          id: "QEH2d5wk2PA",
          title: "ලෝක සිවංකර මුණිගුණ වරුණ"
        },
        // {
        //   id: "",
        //   title: "සති සම්බොජ්ඣංග දේශනය"
        // },
        {
          id: "DU-8B0tjgn0",
          title: "ධම්මවිචය සම්බොඡ්ඣංග දේශනය"
        },
        // {
        //   id: "",
        //   title: "වීර්‍ය සම්බොජ්ජංග දේශනාව"
        // },
        {
          id: "z4EjJVWoMms",
          title: "අසිරිමත් බුදුගුණ දේශනාව"
        },
        {
          id: "-NVfvfh6iCA",
          title: "සිල් සුවඳෙහි රැඳි දෙලොව දිනන මග"
        },
        {
          id: "qInQsb1WA7c",
          title: "සංඛාරුප්පත්ති සූත්‍රය"
        },
        // {
        //   id: "",
        //   title: "පටිච්ච සමුප්පාදය"
        // },
        {
          id: "PIQnFQWJuoA",
          title: "අච්ඡරියබ්භූත සූත්‍රය"
        },
        {
          id: "m7O8WphSH3Y",
          title: "ලක්ඛණ සූත්‍රය"
        },
        {
          id: "Fa-IHe5U7R0",
          title: "ගිලාන සූත්‍රය"
        },
        {
          id: "8yiLYudGsao",
          title: "චුළකම්මවිභංග සූත්‍රය"
        },
        {
          id: "N4Nu0Bp2ZX4",
          title: "ඨාන සුත්‍රය"
        },
        {
          id: "ImVUVNRo_Ps",
          title: "මහා සීහනාද සූත්‍රය"
        },
        {
          id: "2QEbOyFOaeM",
          title: "පත්තකම්ම සූත්‍රය"
        },
        {
          id: "3YbD1eKSFIk",
          title: "වේළුද්වාර සූත්‍රය"
        },
        {
          id: "bT7wqkg3Y6c",
          title: "අරිය පර්යේසන සූත්‍රය"
        },
        // {
        //   id: "",
        //   title: "සෝමාවතී මහ සෑ වරුණ"
        // },
        // {
        //   id: "",
        //   title: "බ්‍රහ්මායු සූත්‍රය"
        // },
        // {
        //   id: "",
        //   title: "ස්වර්ණමාලී මහා සෑ වරුණ"
        // },
        {
          id: "ecBaDY4UdhA",
          title: "රට්ඨපාල සූත්‍රය"
        },
        // {
        //   id: "",
        //   title: "ප්‍රඥා ධර්ම දේශනාව"
        // },
        {
          id: "YKHzpxAdc8U",
          title: "සම්බුදු සිරිත"
        },
        {
          id: "cADAxv4qxJM",
          title: "සක්කපඤ්හ සූත්‍රය"
        },
        {
          id: "teLyYznfp7E",
          title: "පුඤ්ඤාභිසන්ද "
        },
        {
          id: "eT7iIz92hNw",
          title: "නිමි ජාතක දේශනාව"
        },
        {
          id: "ZiZCeILv5Gs",
          title: "ශ්‍රී සම්බුද්ධ ඤාණ වන්දනාව"
        },
        {
          id: "ceFxgH5KM-s",
          title: "සද්ධර්ම යාගය"
        },
        {
          id: "cPkHoyOgYHA",
          title: "පාරායන වග්ග සජ්ඣායනය"
        },
        {
          id: "jMhgkzylXlo",
          title: "ධර්ම සාකච්ඡාව 01"
        },
        {
          id: "QUyHDF1PJ_Q",
          title: "ධර්ම සාකච්ඡාව 02"
        },
        {
          id: "BRdLfUbTxas",
          title: "ධර්ම සාකච්ඡාව 03"
        },
        {
          id: "YuXffwEdx50",
          title: "ධර්ම සාකච්ඡාව 04"
        },
        {
          id: "HJQoVk6PMlo",
          title: "ධර්ම සාකච්ඡාව 05"
        },
        {
          id: "r6NdjJIcn1k",
          title: "ධර්ම සාකච්ඡාව 06"
        },
        {
          id: "YA-oLXPGICc",
          title: "දම් නිරිඳු රූ සොභා"
        },
        {
          id: "8gkXBcZYHOI",
          title: "චක්කවත්ති සීහනාද සූත්‍රය"
        },
        {
          id: "gjte0Stk76I",
          title: "මහා ආර්යවංශ දේශනාව 01"
        },
        {
          id: "qK0hge4bb4I",
          title: "මහා ආර්යවංශ දේශනාව 02"
        },
        {
          id: "MgYAIlejIaE",
          title: "මහාවංශ විවරණය හැදින්වීම"
        },
        {
          id: "uTuFALI3OH8",
          title: "මහාවංශ විවරණය 01"
        },
        {
          id: "_2S_QbPAUaM",
          title: "මහාවංශ විවරණය 02"
        },
        {
          id: "sBPjFTNMPWA",
          title: "මහාවංශ විවරණය 03"
        },
        {
          id: "XRxQi0nFK2k",
          title: "මහාවංශ විවරණය 04"
        },
        {
          id: "VRa2V59Tx1k",
          title: "මහාවංශ විවරණය 05"
        },
        {
          id: "9AIspwRzhjg",
          title: "මහාවංශ විවරණය 06"
        }
      ]
    };
  }
};
</script>
